import React, { lazy } from 'react';
import { motion } from 'framer-motion';
type Testimonial = {
  name: string;
  role: string;
  avatar: string;
  quote: string;
  highlight: string;
};
const testimonials: Testimonial[] = [{
  name: 'Martín Sosa',
  role: '🇦🇷 Entrenador U12 · Buenos Aires, Argentina',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  quote: 'Antes pasaba dos horas cada noche armando el entrenamiento. Con el Megapack llego al club con la sesión lista y los chicos rinden mejor.',
  highlight: 'Recuperé mis noches en una semana.'
}, {
  name: 'Carlos Hernández',
  role: '🇲🇽 Profesor de Educación Física · Guadalajara, México',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=faces',
  quote: 'Las sesiones por categoría son oro puro. Tengo todo el ciclo escolar planificado y los papás notaron la diferencia en los partidos.',
  highlight: 'Todo el ciclo planificado.'
}, {
  name: 'Diego Ramírez',
  role: '🇺🇾 Entrenador U15 · Montevideo, Uruguay',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
  quote: 'El Manual de Portería me destrabó algo que venía postergando hace años. Mis arqueros mejoraron muchísimo en 2 meses.',
  highlight: 'Mis arqueros cambiaron por completo.'
}, {
  name: 'Valentina Restrepo',
  role: '🇨🇴 Entrenadora U10 · Medellín, Colombia',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces',
  quote: 'Lo que más valoro es la pizarra HD. Imprimo, marco y las niñas entienden la jugada al instante. Vale 10 veces lo que pagué.',
  highlight: 'Vale 10 veces lo que pagué.'
}, {
  name: 'Javier Domínguez',
  role: '🇪🇸 Director Deportivo · Valencia, España',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=faces',
  quote: 'Lo compré para mi staff. Ahora todos los entrenadores del club hablan el mismo idioma y las planificaciones son consistentes.',
  highlight: 'Unificó a todo el staff del club.'
}, {
  name: 'Andrea Castillo',
  role: '🇨🇱 Entrenadora U12 · Santiago, Chile',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&h=200&fit=crop&crop=faces',
  quote: 'Pensé que sería un PDF más. Me equivoqué. Es un sistema completo, ordenado y aplicable desde el primer día.',
  highlight: 'Aplicable desde el primer día.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-250">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-251"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-252">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16" data-id="element-253">
          <span className="inline-block text-secondary font-bold text-xs sm:text-sm tracking-widest uppercase mb-3" data-id="element-254">
            ⭐ Lo que dicen los entrenadores
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-255">
            +500 entrenadores ya{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-256">
              recuperaron su tiempo
            </span>
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-257">
            <span className="text-secondary text-lg sm:text-xl drop-shadow-[0_0_8px_rgba(245,158,11,0.5)]" data-id="element-258">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-259">
              4.9/5 · Reseñas verificadas
            </span>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-260">
          {testimonials.map((t, i) => <motion.article key={t.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.08,
          duration: 0.5
        }} className="bg-bg-alt border border-border-light rounded-2xl p-5 sm:p-7 flex flex-col h-full hover:border-primary/40 transition-colors shadow-[0_0_30px_rgba(0,0,0,0.2)]" data-id="element-261">
              {/* Stars */}
              <div className="text-secondary text-sm mb-3 drop-shadow-[0_0_6px_rgba(245,158,11,0.4)]" data-id="element-262">
                ⭐⭐⭐⭐⭐
              </div>

              {/* Highlight quote */}
              <p className="text-text-main font-bold text-base sm:text-lg leading-snug mb-3" data-id="element-263">
                "{t.highlight}"
              </p>

              {/* Full quote */}
              <p className="text-text-sec text-sm sm:text-base leading-relaxed mb-6 flex-1" data-id="element-264">
                {t.quote}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-265">
                <img src={t.avatar} alt={t.name} loading="lazy" decoding="async" width={44} height={44} className="w-11 h-11 rounded-full object-cover border-2 border-primary/30" data-id="element-266" />
                <div className="min-w-0" data-id="element-267">
                  <div className="flex items-center gap-1.5" data-id="element-268">
                    <span className="text-text-main font-bold text-sm truncate" data-id="element-269">
                      {t.name}
                    </span>
                    <span className="text-primary text-xs flex-shrink-0" title="Compra verificada" data-id="element-270">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-sec text-xs truncate" data-id="element-271">{t.role}</p>
                </div>
              </div>
            </motion.article>)}
        </div>

        {/* CTA */}
        <div className="text-center mt-10 sm:mt-14" data-id="element-272">
          <a href="#pricing" className="inline-block bg-cta-green hover:bg-cta-green-hover text-white font-black text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl transition-all shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-273">
            🚀 QUIERO SUMARME A ELLOS
          </a>
          <p className="text-text-sec text-xs sm:text-sm mt-3 font-medium" data-id="element-274">
            Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}